import './AppIcon.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var icon = _7a468({defaultClassName:'_1dtfpz51-3-5-0',variantClassNames:{fadeIn:{true:'_1dtfpz52-3-5-0'}},defaultVariants:{},compoundVariants:[]});